import { ValuesOf } from '../../types';

import { OrderStatus, ORDER_UNCONFIRMED_STATUSES } from '../../constants';

type Status = ValuesOf<OrderStatus>;

const isOrderUnconfirmed = (status?: Status): boolean =>
  status
    ? (ORDER_UNCONFIRMED_STATUSES as ReadonlyArray<Status>).includes(status)
    : false;

export default isOrderUnconfirmed;
